export const SEARCHLIMIT = 50;

export default {
  SEARCHLIMIT,
};
